import Icon from 'vue-awesome/components/Icon'

Icon.register({
  details_rounded: {
    paths: [
      {
        d: 'M3.84 5.49l7.29 12.96c.38.68 1.36.68 1.74 0l7.29-12.96A.998.998 0 0019.29 4H4.71c-.76 0-1.25.82-.87 1.49zM6.38 6h11.25L12 16 6.38 6z'
      }
    ],
    width: '24',
    height: '24'
  }
})
